'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExistingAccountsActionTypes = (0, _keyMirror2.default)({
  ACCOUNTS_REQUESTED: null,
  ACCOUNTS_FETCHED: null,
  ACCOUNTS_FETCHED_FAILED: null
});

exports.default = ExistingAccountsActionTypes;
module.exports = exports['default'];